// frontend/src/components/ProfileBlockEditors/ImageBlockEditor.js
import React, { useState } from 'react';
import axios from 'axios';
import {
    CloudUploadIcon as UploadIcon,
    DeleteIcon
} from '../Icons';

const ImageBlockEditor = ({ block, onChange, teamMemberId }) => {
    const [uploading, setUploading] = useState(false);

    const handleTitleChange = (title) => {
        onChange({
            ...block,
            content: {
                ...block.content,
                title
            }
        });
    };

    const handleCaptionChange = (caption) => {
        onChange({
            ...block,
            content: {
                ...block.content,
                caption
            }
        });
    };

    const handleImageUpload = async (file) => {
        if (!file) return;

        setUploading(true);
        const storedUser = localStorage.getItem('user');
        const token = storedUser ? JSON.parse(storedUser).token : null;

        try {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                const base64 = reader.result.split(',')[1];

                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL}/api/team/${teamMemberId}/photo`,
                    { image: base64 },
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                // Get the newly uploaded photo URL
                const newPhotoUrl = response.data.photos[response.data.photos.length - 1].url;

                onChange({
                    ...block,
                    content: {
                        ...block.content,
                        imageUrl: newPhotoUrl
                    }
                });
            };
        } catch (error) {
            console.error('Error uploading image:', error);
            alert('Fehler beim Hochladen des Bildes');
        } finally {
            setUploading(false);
        }
    };

    const handleRemoveImage = () => {
        onChange({
            ...block,
            content: {
                ...block.content,
                imageUrl: ''
            }
        });
    };

    return (
        <div className="flex flex-col gap-4">
            <div>
                <label className="block text-label-large text-surface-onVariant mb-1">
                    Titel
                </label>
                <input
                    type="text"
                    value={block.content?.title || ''}
                    onChange={(e) => handleTitleChange(e.target.value)}
                    placeholder="z.B. Mein schönstes Lager"
                    className="md3-textfield-outlined w-full"
                />
            </div>

            <div>
                <span className="block text-label-small text-surface-onVariant mb-1">Bild</span>
                {block.content?.imageUrl ? (
                    <div className="relative rounded-lg overflow-hidden border border-divider group">
                        <img
                            src={block.content.imageUrl}
                            alt="Preview"
                            className="w-full h-48 object-cover block"
                        />
                        <button
                            onClick={handleRemoveImage}
                            className="absolute top-2 right-2 bg-black/60 text-white rounded-full p-1 hover:bg-black/80 transition-colors opacity-0 group-hover:opacity-100"
                            title="Entfernen"
                        >
                            <DeleteIcon fontSize="small" />
                        </button>
                    </div>
                ) : (
                    <label className={`
                        h-36 flex flex-col items-center justify-center border-2 border-dashed rounded-lg cursor-pointer transition-colors
                        ${uploading ? 'bg-surface-containerHigh border-outline' : 'bg-surface-container hover:bg-surface-containerHigh hover:border-primary border-outlineVariant text-surface-onVariant hover:text-primary'}
                    `}>
                        {uploading ? (
                            <div className="md3-progress-circular w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin"></div>
                        ) : (
                            <UploadIcon sx={{ fontSize: 40, mb: 1, color: 'inherit' }} />
                        )}
                        <span className="text-body-medium font-medium mt-1">
                            {uploading ? 'Lädt hoch...' : 'Bild hochladen'}
                        </span>
                        <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={(e) => handleImageUpload(e.target.files[0])}
                            disabled={uploading}
                        />
                    </label>
                )}
            </div>

            <div>
                <label className="block text-label-large text-surface-onVariant mb-1">
                    Bildunterschrift (optional)
                </label>
                <input
                    type="text"
                    value={block.content?.caption || ''}
                    onChange={(e) => handleCaptionChange(e.target.value)}
                    placeholder="Beschreibe das Bild..."
                    className="md3-textfield-outlined w-full"
                />
            </div>
        </div>
    );
};

export default ImageBlockEditor;
